// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =========================================================
   UserAgreement – COMPLETE CSS (for Next.js page.css paste)
   Page: src/ui/Pages/UserAgreement/index.js
   Sources:
   A) public/css-new/style.css + light_theme.css  (shell / globals)
   B) src/ui/Pages/UserAgreement/user-agreement.css (page-specific)
   Bootstrap utilities NOT included — load Bootstrap separately.
   Remix Icon (ri-*) NOT included — load remixicon CSS separately.
   ========================================================= */


/* ========== A1. GLOBAL BASE (style.css) ========== */

body {
  font-family: "Inter", sans-serif;
  background-color: #181A20;
  overflow-x: hidden;
  max-width: 100%;
  position: relative;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizeLegibility;
  text-rendering: geometricPrecision;
  font-weight: 400;
}

@supports (overflow: clip) {
  body {
    overflow-x: clip;
    overflow-y: auto;
  }
}

body {
  background-color: #000;
}

html {
  scroll-behavior: auto !important;
  overflow-x: hidden;
  max-width: 100%;
  overscroll-behavior-x: none;
}

@supports (overflow: clip) {
  html {
    overflow-x: clip;
    overflow-y: auto;
  }
}

#root {
  overflow-x: hidden;
  max-width: 100%;
}

@supports (overflow: clip) {
  #root {
    overflow-x: clip;
    overflow-y: visible;
  }
}

#root:has(header.sticky-top) {
  padding-top: 58px;
}

html:has(header.sticky-top) {
  scroll-padding-top: 58px;
}

h1 {
  font-family: "Inter", sans-serif;
  font-size: 3.2rem;
}

a {
  text-decoration: none;
  transition: 0.5s all;
}

img {
  max-width: 100%;
}

ul {
  list-style: none;
  padding: 0px;
  margin: 0px;
}

p {
  font-size: 18px;
  line-height: 140%;
  font-weight: 300;
}


/* ========== A2. CONTAINER OVERRIDE (style.css) ========== */

.container,
.container-lg,
.container-md,
.container-sm,
.container-xl,
.container-xxl {
  max-width: 1380px;
  padding: 0px 20px;
}


/* ========== A3. HERO / TITLE SHELL (style.css) ========== */

.hero-banner-style.top-section-gap {
  color: #fff;
}

section.faq_sec {
  padding: 40px 0px 0px;
}

section.faq_sec .section-title {
  margin-bottom: 20px;
}

.section-title {
  margin-bottom: 60px;
}

.text-gradient {
  color: #D1AA67;
}


/* ========== A4. LIGHT THEME SHELL (light_theme.css) ========== */

body.light_theme {
  background-color: #fff !important;
}

body.light_theme .hero-banner-style.top-section-gap {
  color: #0a0a0a;
}


/* ========== A5. SHELL RESPONSIVE (style.css) ========== */

@media screen and (max-width:1700px) {

  .container,
  .container-lg,
  .container-md,
  .container-sm,
  .container-xl,
  .container-xxl {
    max-width: 90%;
  }
}

@media screen and (max-width:1440px) {
  h1 {
    font-size: 2.8rem;
  }

  #root:has(header.sticky-top) {
    padding-top: 40px;
  }

  html:has(header.sticky-top) {
    scroll-padding-top: 40px;
  }
}

@media screen and (max-width:1367px) {
  h1 {
    font-size: 2.5rem;
  }

  h1 {
    font-size: 2.2rem;
  }
}

@media screen and (max-width:1200px) {

  .container,
  .container-lg,
  .container-md,
  .container-sm,
  .container-xl,
  .container-xxl {
    max-width: 95%;
  }

  .section-title {
    margin-bottom: 30px;
  }

  p {
    font-size: 16px;
  }
}

@media screen and (max-width:991px) {
  .hero-banner-style.top-section-gap section.faq_sec {
    padding: 50px 0px 0px;
  }

  section.faq_sec {
    padding: 20px 0px 0px;
  }

  p {
    font-size: 14px;
  }
}

@media screen and (max-width:767px) {
  #root:has(header.sticky-top) {
    padding-top: 40px;
  }

  html:has(header.sticky-top) {
    padding-top: 0px;
  }

  section.faq_sec .section-title {
    margin-bottom: 0px;
  }

  h1 {
    font-size: 1.7rem;
  }

  p {
    font-size: 14px;
  }

  .container,
  .container-lg,
  .container-md,
  .container-sm,
  .container-xl,
  .container-xxl {
    max-width: 98%;
  }

  .hero-banner-style.top-section-gap section.faq_sec {
    padding: 35px 0px 0px;
  }
}

@media screen and (max-width:480px) {
  p {
    font-size: 12px;
  }
}

@media screen and (max-width:414px) {
  p {
    font-size: 12px;
  }
}


/* =========================================================
   B) PAGE-SPECIFIC (user-agreement.css — as-is)
   ========================================================= */

/* ── User Agreement Page Styles ── */

.user_agreement {
  padding-top: 10px;
  padding-bottom: 80px;
  font-family: "Inter", sans-serif;
  color: #f0f0f0;
}

body.light_theme .user_agreement {
  color: #1e293b;
}

.agcex-ua-hero {
  text-align: center;
  margin-bottom: 30px;
}

.agcex-ua-hero h1 {
  font-size: 32px;
  font-weight: 800;
  margin-bottom: 6px;
}

.agcex-ua-hero .agcex-ua-subtitle {
  font-size: 16px;
  font-weight: 600;
  color: #f3f3f3;
  margin-bottom: 4px;
}

body.light_theme .agcex-ua-hero .agcex-ua-subtitle {
  color: #64748b;
}

.agcex-ua-hero .agcex-ua-company {
  font-size: 15px;
  font-weight: 700;
  color: #e2e2e2;
}

body.light_theme .agcex-ua-hero .agcex-ua-company {
  color: #475569;
}

.agcex-ua-hero .agcex-ua-meta {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 24px;
  margin-top: 12px;
  font-size: 13px;
  color: #94a3b8;
  font-weight: 500;
}

.agcex-ua-hero .agcex-ua-meta span {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  text-align: left;
}

.agcex-ua-card {
  background: #ffffff12;
  border: 1px solid #e2e8f014;
  border-radius: 16px;
  padding: 40px 32px;
  max-width: 90%;
  margin: 0 auto;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.03);
}

body.light_theme .agcex-ua-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
}

@media (max-width: 767px) {
  .agcex-ua-card {
    padding: 24px 18px;
    border-radius: 12px;
    max-width: 100%;
  }

  .agcex-ua-hero h1 {
    font-size: 24px;
  }

  .agcex-ua-hero .agcex-ua-meta {
    flex-wrap: wrap;
    gap: 12px;
  }
}

/* Summary Table */
.agcex-ua-summary-table-wrapper {
  margin-bottom: 30px;
  overflow-x: auto;
  border: 1px solid #e2e8f021;
  border-radius: 12px;
  background: #f8fafc14;

}

body.light_theme .agcex-ua-summary-table-wrapper {
  border: 1px solid #e2e8f0;
  background: #f8fafc;
}

.agcex-ua-summary-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.agcex-ua-summary-table tr {
  border-bottom: 1px solid #e2e8f026;
}

body.light_theme .agcex-ua-summary-table tr {
  border-bottom: 1px solid #e2e8f0;
}

.agcex-ua-summary-table tr:last-child {
  border-bottom: none;
}

.agcex-ua-summary-table .agcex-ua-label {
  font-weight: 600;
  color: #ededed;
  padding: 14px 20px;
  width: 280px;
  background: #383b40;
  border-right: 1px solid #e2e8f029;
}

body.light_theme .agcex-ua-summary-table .agcex-ua-label {
  background: #f1f5f9;
  border-right: 1px solid #e2e8f0;
  color: #0f172a;
}

.agcex-ua-summary-table .agcex-ua-value {
  color: #e7e7e7;
  padding: 14px 20px;
}

body.light_theme .agcex-ua-summary-table .agcex-ua-value {
  color: #475569;
}

.agcex-ua-summary-table .agcex-ua-value a {
  color: #ce9f4e;
  text-decoration: none;
  font-weight: 500;
}

.agcex-ua-summary-table .agcex-ua-value a:hover {
  text-decoration: underline;
}

@media (max-width: 575px) {
  .agcex-ua-summary-table .agcex-ua-label {
    width: 140px;
    padding: 12px 14px;
    font-size: 13px;
  }

  .agcex-ua-summary-table .agcex-ua-value {
    padding: 12px 14px;
    font-size: 13px;
  }
}

/* Intro Box */
.agcex-ua-intro-box {
  background: #f8fafc14;
  border: 1px solid #cbd5e129;
  border-radius: 12px;
  padding: 22px 26px;
  margin-bottom: 36px;
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.02);
}

body.light_theme .agcex-ua-intro-box {
  background: #f8fafc;
  border: 1px solid #cbd5e1;
}

.agcex-ua-intro-box p {
  font-size: 14px;
  line-height: 1.8;
  color: #ededed;
  margin: 0;
}

body.light_theme .agcex-ua-intro-box p {
  color: #475569;
}

/* Table of Contents */
.agcex-ua-toc {
  background: #383b40;
  border: 1px solid #e2e8f01f;
  border-radius: 12px;
  padding: 28px 32px;
  margin-bottom: 40px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.02);
}

body.light_theme .agcex-ua-toc {
  background: #ffffff;
  border: 1px solid #e2e8f0;
}

.agcex-ua-toc h3 {
  font-size: 18px;
  font-weight: 700;
  color: #ececec;
  margin: 0 0 20px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 2px solid #e2e8f014;
  padding-bottom: 12px;
}

body.light_theme .agcex-ua-toc h3 {
  color: #0f172a;
  border-bottom: 2px solid #e2e8f0;
}

.agcex-ua-toc-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 40px;
  row-gap: 12px;
}

@media (max-width: 767px) {
  .agcex-ua-toc-grid {
    grid-template-columns: 1fr;
  }

  .agcex-ua-toc {
    padding: 20px 22px;
  }
}

.agcex-ua-toc-item {
  display: flex;
  align-items: center;
  gap: 14px;
  font-size: 14.5px;
  color: #f5f5f5;
  text-decoration: none;
  padding: 4px 0;
  transition: all 0.2s ease;
}

body.light_theme .agcex-ua-toc-item {
  color: #475569;
}

.agcex-ua-toc-item:hover {
  color: #ce9f4e;
}

.agcex-ua-toc-number {
  width: 26px;
  text-align: right;
  font-weight: 600;
  color: #f0f0f0;
  font-size: 14px;
}

body.light_theme .agcex-ua-toc-number {
  color: #94a3b8;
}

/* Sections */
.agcex-ua-section {
  margin-bottom: 42px;
}

.agcex-ua-section:last-child {
  margin-bottom: 0;
}

.agcex-ua-section-number {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 8px;
  background: linear-gradient(135deg, #d1aa67, #f5c573);
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  margin-right: 12px;
  flex-shrink: 0;
}

.agcex-ua-section h2 {
  display: flex;
  align-items: center;
  font-size: 20px;
  font-weight: 700;
  color: #ececec;
  margin: 0 0 20px;
  padding-bottom: 12px;
  border-bottom: 1px solid #e2e8f01f;
}

body.light_theme .agcex-ua-section h2 {
  color: #0f172a;
  border-bottom: 1px solid #e2e8f0;
}

.agcex-ua-section p {
  font-size: 14.5px;
  line-height: 1.75;
  color: #f3f3f3;
  margin: 0 0 16px;
}

body.light_theme .agcex-ua-section p {
  color: #475569;
}

.agcex-ua-section p:last-child {
  margin-bottom: 0;
}

/* Definitions List */
.agcex-ua-definition-item {
  margin-bottom: 22px;
  padding-left: 16px;
  border-left: 3px solid #e2e8f029;
}

body.light_theme .agcex-ua-definition-item {
  border-left: 3px solid #cbd5e1;
}

.agcex-ua-definition-item:last-child {
  margin-bottom: 0;
}

.agcex-ua-definition-item strong {
  display: block;
  font-size: 15px;
  font-weight: 700;
  color: #f0f0f0;
  margin-bottom: 6px;
}

body.light_theme .agcex-ua-definition-item strong {
  color: #0f172a;
}

.agcex-ua-definition-item p {
  margin: 0;
  font-size: 14.5px;
  color: #f0f0f0;
  line-height: 1.7;
}

body.light_theme .agcex-ua-definition-item p {
  color: #475569;
}

.agcex-ua-text-list p {
  margin-bottom: 18px;
  padding-left: 12px;
  border-left: 3px solid #e2e8f021;
}

body.light_theme .agcex-ua-text-list p {
  border-left: 3px solid #e2e8f0;
}

.agcex-ua-text-list p strong {
  color: #f1f1f1;
}

body.light_theme .agcex-ua-text-list p strong {
  color: #0f172a;
}

.agcex-ua-section ul {
  list-style: none;
  padding: 0;
  margin: 0 0 20px;
}

.agcex-ua-section ul li {
  position: relative;
  padding-left: 24px;
  margin-bottom: 12px;
  font-size: 14.5px;
  line-height: 1.7;
  color: #dfdfdf;
}

body.light_theme .agcex-ua-section ul li {
  color: #475569;
}

.agcex-ua-section ul li strong {
  color: #f1f1f1;
}

body.light_theme .agcex-ua-section ul li strong {
  color: #0f172a;
}

.agcex-ua-section ul li::before {
  content: "";
  position: absolute;
  left: 4px;
  top: 10px;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: linear-gradient(135deg, #dbb26a, #f1c171);
}

/* Sub Articles */
.agcex-ua-sub-article {
  margin-top: 24px;
  margin-bottom: 24px;
  padding-left: 16px;
  border-left: 2px solid #e2e8f029;
}

body.light_theme .agcex-ua-sub-article {
  border-left: 2px solid #cbd5e1;
}

.agcex-ua-sub-article h3 {
  font-size: 16px;
  font-weight: 700;
  color: #ececec;
  margin: 0 0 10px;
}

body.light_theme .agcex-ua-sub-article h3 {
  color: #0f172a;
}

/* Purpose Table */
.agcex-ua-table-responsive {
  overflow-x: auto;
  margin-top: 20px;
  margin-bottom: 20px;
  border: 1px solid #e2e8f021;
  border-radius: 12px;
}

body.light_theme .agcex-ua-table-responsive {
  border: 1px solid #e2e8f0;
}

.agcex-ua-purpose-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.agcex-ua-purpose-table th,
.agcex-ua-purpose-table td {
  padding: 14px 18px;
  text-align: left;
  border-bottom: 1px solid #e2e8f021;
  line-height: 1.6;
}

body.light_theme .agcex-ua-purpose-table th,
body.light_theme .agcex-ua-purpose-table td {
  border-bottom: 1px solid #e2e8f0;
}

.agcex-ua-purpose-table th {
  background: #383b40;
  font-weight: 700;
  color: #ededed;
  font-size: 14px;
  border-bottom: 2px solid #e2e8f029;
}

body.light_theme .agcex-ua-purpose-table th {
  background: #f8fafc;
  color: #0f172a;
  border-bottom: 2px solid #e2e8f0;
}

.agcex-ua-purpose-table td {
  color: #dfdfdf;
}

body.light_theme .agcex-ua-purpose-table td {
  color: #475569;
}

.agcex-ua-purpose-table tr:last-child td {
  border-bottom: none;
}

.agcex-ua-purpose-table tbody tr:nth-child(even) {
  background-color: #ffffff0a;
}

body.light_theme .agcex-ua-purpose-table tbody tr:nth-child(even) {
  background-color: #fcfcfd;
}

.agcex-ua-purpose-table td strong {
  color: #f5f5f5;
}

body.light_theme .agcex-ua-purpose-table td strong {
  color: #0f172a;
}

/* Contact Box & Table Wrapper */
.agcex-ua-contact-box {
  background: #f8fafc14;
  border: 1px solid #e2e8f021;
  border-radius: 12px;
  padding: 24px 28px;
  margin-top: 28px;
}

body.light_theme .agcex-ua-contact-box {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
}

.agcex-ua-contact-box h3 {
  font-size: 17px;
  font-weight: 700;
  color: #ececec;
  margin: 0 0 12px;
}

body.light_theme .agcex-ua-contact-box h3 {
  color: #0f172a;
}

.agcex-ua-contact-box p {
  font-size: 14px;
  margin-bottom: 16px;
}

.agcex-ua-contact-table-wrapper {
  margin-top: 20px;
  margin-bottom: 24px;
}

/* Confirmation Divider & Text */
.agcex-ua-divider {
  border: 0;
  height: 1px;
  background: #e2e8f029;
  margin: 40px 0 24px;
}

body.light_theme .agcex-ua-divider {
  background: #e2e8f0;
}

.agcex-ua-confirmation-text {
  font-size: 15px;
  line-height: 1.7;
  color: #ebebeb;
  margin-bottom: 36px;
}

body.light_theme .agcex-ua-confirmation-text {
  color: #334155;
}

/* Footer Grid */
.agcex-ua-footer-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  background: #f8fafc12;
  border: 1px solid #cbd5e114;
  border-radius: 12px;
  overflow: hidden;
  margin-bottom: 24px;
}

body.light_theme .agcex-ua-footer-grid {
  background: #f8fafc;
  border: 1px solid #cbd5e1;
}

.agcex-ua-footer-col {
  padding: 20px 24px;
  border-right: 1px solid #4c4c4c;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

body.light_theme .agcex-ua-footer-col {
  border-right: 1px solid #cbd5e1;
}

.agcex-ua-footer-col:last-child {
  border-right: none;
}

.agcex-ua-footer-col strong {
  font-size: 14px;
  font-weight: 700;
  color: #f5f5f5;
  margin-bottom: 4px;
}

body.light_theme .agcex-ua-footer-col strong {
  color: #0f172a;
}

.agcex-ua-footer-col span {
  font-size: 13.5px;
  color: #d9d9d9;
  line-height: 1.5;
}

body.light_theme .agcex-ua-footer-col span {
  color: #475569;
}

.agcex-ua-footer-col span a {
  color: #ce9f4e;
  text-decoration: none;
}

.agcex-ua-footer-col span a:hover {
  text-decoration: underline;
}

/* Copyright Statement */
.agcex-ua-copyright {
  text-align: center;
  font-size: 13px;
  color: #e4e4e4;
  padding-top: 20px;
  border-top: 1px solid #535353;
}

body.light_theme .agcex-ua-copyright {
  color: #64748b;
  border-top: 1px solid #e2e8f0;
}

@media (max-width: 991px) {
  .user_agreement {
    padding-top: 20px;
  }

  .agcex-ua-section h2 {
    font-size: 18px;
  }

  .agcex-ua-footer-grid {
    grid-template-columns: 1fr;
  }

  .agcex-ua-footer-col {
    border-right: none;
    border-bottom: 1px solid #4c4c4c;
  }

  body.light_theme .agcex-ua-footer-col {
    border-right: none;
    border-bottom: 1px solid #cbd5e1;
  }

  .agcex-ua-footer-col:last-child {
    border-bottom: none;
  }
}

.agcex-ua-risk-summary-box {
  border-radius: 8px;
  padding: 16px 20px;
  margin-bottom: 24px;
  font-size: 13.5px;
  font-weight: 700;
  line-height: 1.6;
  border: 1px solid #424242;
  color: #ffffff;
  background-color: #ffffff0f;
  letter-spacing: 0.2px;
  text-align: justify;
}

body.light_theme .agcex-ua-risk-summary-box {
  border: 1px solid #0f172a;
  color: #0f172a;
  background-color: #ffffff;
}


@media screen and (max-width:1200px) {

  .user_agreement .agcex-ua-card {
    max-width: 100%;
  }

  .agcex-ua-section p {
    font-size: 14px;
  }

}`, "",{"version":3,"sources":["webpack://./src/ui/Pages/UserAgreement/user-agreement.css"],"names":[],"mappings":"AAAA;;;;;;;;8DAQ8D;;;AAG9D,sDAAsD;;AAEtD;EACE,gCAAgC;EAChC,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,mCAAmC;EACnC,kCAAkC;EAClC,kCAAkC;EAClC,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE;IACE,gBAAgB;IAChB,gBAAgB;EAClB;AACF;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE;IACE,gBAAgB;IAChB,gBAAgB;EAClB;AACF;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE;IACE,gBAAgB;IAChB,mBAAmB;EACrB;AACF;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;;AAGA,6DAA6D;;AAE7D;;;;;;EAME,iBAAiB;EACjB,iBAAiB;AACnB;;;AAGA,6DAA6D;;AAE7D;EACE,WAAW;AACb;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;;AAGA,kEAAkE;;AAElE;EACE,iCAAiC;AACnC;;AAEA;EACE,cAAc;AAChB;;;AAGA,2DAA2D;;AAE3D;;EAEE;;;;;;IAME,cAAc;EAChB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;;EAEE;;;;;;IAME,cAAc;EAChB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;;;;;;IAME,cAAc;EAChB;;EAEA;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;;AAGA;;8DAE8D;;AAE9D,qCAAqC;;AAErC;EACE,iBAAiB;EACjB,oBAAoB;EACpB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE;IACE,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;AACF;;AAEA,kBAAkB;AAClB;EACE,mBAAmB;EACnB,gBAAgB;EAChB,2BAA2B;EAC3B,mBAAmB;EACnB,qBAAqB;;AAEvB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE;IACE,YAAY;IACZ,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;AACF;;AAEA,cAAc;AACd;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,kCAAkC;EAClC,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA,aAAa;AACb;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qDAAqD;EACrD,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,qDAAqD;AACvD;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,gCAAgC;AAChC;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,gCAAgC;AAChC;EACE,SAAS;EACT,WAAW;EACX,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,qCAAqC;EACrC,qBAAqB;EACrB,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;IAClB,gCAAgC;EAClC;;EAEA;IACE,kBAAkB;IAClB,gCAAgC;EAClC;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,2BAA2B;EAC3B,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;;AAGA;;EAEE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;AAEF","sourcesContent":["/* =========================================================\n   UserAgreement – COMPLETE CSS (for Next.js page.css paste)\n   Page: src/ui/Pages/UserAgreement/index.js\n   Sources:\n   A) public/css-new/style.css + light_theme.css  (shell / globals)\n   B) src/ui/Pages/UserAgreement/user-agreement.css (page-specific)\n   Bootstrap utilities NOT included — load Bootstrap separately.\n   Remix Icon (ri-*) NOT included — load remixicon CSS separately.\n   ========================================================= */\n\n\n/* ========== A1. GLOBAL BASE (style.css) ========== */\n\nbody {\n  font-family: \"Inter\", sans-serif;\n  background-color: #181A20;\n  overflow-x: hidden;\n  max-width: 100%;\n  position: relative;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  text-rendering: optimizeLegibility;\n  text-rendering: geometricPrecision;\n  font-weight: 400;\n}\n\n@supports (overflow: clip) {\n  body {\n    overflow-x: clip;\n    overflow-y: auto;\n  }\n}\n\nbody {\n  background-color: #000;\n}\n\nhtml {\n  scroll-behavior: auto !important;\n  overflow-x: hidden;\n  max-width: 100%;\n  overscroll-behavior-x: none;\n}\n\n@supports (overflow: clip) {\n  html {\n    overflow-x: clip;\n    overflow-y: auto;\n  }\n}\n\n#root {\n  overflow-x: hidden;\n  max-width: 100%;\n}\n\n@supports (overflow: clip) {\n  #root {\n    overflow-x: clip;\n    overflow-y: visible;\n  }\n}\n\n#root:has(header.sticky-top) {\n  padding-top: 58px;\n}\n\nhtml:has(header.sticky-top) {\n  scroll-padding-top: 58px;\n}\n\nh1 {\n  font-family: \"Inter\", sans-serif;\n  font-size: 3.2rem;\n}\n\na {\n  text-decoration: none;\n  transition: 0.5s all;\n}\n\nimg {\n  max-width: 100%;\n}\n\nul {\n  list-style: none;\n  padding: 0px;\n  margin: 0px;\n}\n\np {\n  font-size: 18px;\n  line-height: 140%;\n  font-weight: 300;\n}\n\n\n/* ========== A2. CONTAINER OVERRIDE (style.css) ========== */\n\n.container,\n.container-lg,\n.container-md,\n.container-sm,\n.container-xl,\n.container-xxl {\n  max-width: 1380px;\n  padding: 0px 20px;\n}\n\n\n/* ========== A3. HERO / TITLE SHELL (style.css) ========== */\n\n.hero-banner-style.top-section-gap {\n  color: #fff;\n}\n\nsection.faq_sec {\n  padding: 40px 0px 0px;\n}\n\nsection.faq_sec .section-title {\n  margin-bottom: 20px;\n}\n\n.section-title {\n  margin-bottom: 60px;\n}\n\n.text-gradient {\n  color: #D1AA67;\n}\n\n\n/* ========== A4. LIGHT THEME SHELL (light_theme.css) ========== */\n\nbody.light_theme {\n  background-color: #fff !important;\n}\n\nbody.light_theme .hero-banner-style.top-section-gap {\n  color: #0a0a0a;\n}\n\n\n/* ========== A5. SHELL RESPONSIVE (style.css) ========== */\n\n@media screen and (max-width:1700px) {\n\n  .container,\n  .container-lg,\n  .container-md,\n  .container-sm,\n  .container-xl,\n  .container-xxl {\n    max-width: 90%;\n  }\n}\n\n@media screen and (max-width:1440px) {\n  h1 {\n    font-size: 2.8rem;\n  }\n\n  #root:has(header.sticky-top) {\n    padding-top: 40px;\n  }\n\n  html:has(header.sticky-top) {\n    scroll-padding-top: 40px;\n  }\n}\n\n@media screen and (max-width:1367px) {\n  h1 {\n    font-size: 2.5rem;\n  }\n\n  h1 {\n    font-size: 2.2rem;\n  }\n}\n\n@media screen and (max-width:1200px) {\n\n  .container,\n  .container-lg,\n  .container-md,\n  .container-sm,\n  .container-xl,\n  .container-xxl {\n    max-width: 95%;\n  }\n\n  .section-title {\n    margin-bottom: 30px;\n  }\n\n  p {\n    font-size: 16px;\n  }\n}\n\n@media screen and (max-width:991px) {\n  .hero-banner-style.top-section-gap section.faq_sec {\n    padding: 50px 0px 0px;\n  }\n\n  section.faq_sec {\n    padding: 20px 0px 0px;\n  }\n\n  p {\n    font-size: 14px;\n  }\n}\n\n@media screen and (max-width:767px) {\n  #root:has(header.sticky-top) {\n    padding-top: 40px;\n  }\n\n  html:has(header.sticky-top) {\n    padding-top: 0px;\n  }\n\n  section.faq_sec .section-title {\n    margin-bottom: 0px;\n  }\n\n  h1 {\n    font-size: 1.7rem;\n  }\n\n  p {\n    font-size: 14px;\n  }\n\n  .container,\n  .container-lg,\n  .container-md,\n  .container-sm,\n  .container-xl,\n  .container-xxl {\n    max-width: 98%;\n  }\n\n  .hero-banner-style.top-section-gap section.faq_sec {\n    padding: 35px 0px 0px;\n  }\n}\n\n@media screen and (max-width:480px) {\n  p {\n    font-size: 12px;\n  }\n}\n\n@media screen and (max-width:414px) {\n  p {\n    font-size: 12px;\n  }\n}\n\n\n/* =========================================================\n   B) PAGE-SPECIFIC (user-agreement.css — as-is)\n   ========================================================= */\n\n/* ── User Agreement Page Styles ── */\n\n.user_agreement {\n  padding-top: 10px;\n  padding-bottom: 80px;\n  font-family: \"Inter\", sans-serif;\n  color: #f0f0f0;\n}\n\nbody.light_theme .user_agreement {\n  color: #1e293b;\n}\n\n.agcex-ua-hero {\n  text-align: center;\n  margin-bottom: 30px;\n}\n\n.agcex-ua-hero h1 {\n  font-size: 32px;\n  font-weight: 800;\n  margin-bottom: 6px;\n}\n\n.agcex-ua-hero .agcex-ua-subtitle {\n  font-size: 16px;\n  font-weight: 600;\n  color: #f3f3f3;\n  margin-bottom: 4px;\n}\n\nbody.light_theme .agcex-ua-hero .agcex-ua-subtitle {\n  color: #64748b;\n}\n\n.agcex-ua-hero .agcex-ua-company {\n  font-size: 15px;\n  font-weight: 700;\n  color: #e2e2e2;\n}\n\nbody.light_theme .agcex-ua-hero .agcex-ua-company {\n  color: #475569;\n}\n\n.agcex-ua-hero .agcex-ua-meta {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 24px;\n  margin-top: 12px;\n  font-size: 13px;\n  color: #94a3b8;\n  font-weight: 500;\n}\n\n.agcex-ua-hero .agcex-ua-meta span {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  text-align: left;\n}\n\n.agcex-ua-card {\n  background: #ffffff12;\n  border: 1px solid #e2e8f014;\n  border-radius: 16px;\n  padding: 40px 32px;\n  max-width: 90%;\n  margin: 0 auto;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.03);\n}\n\nbody.light_theme .agcex-ua-card {\n  background: #ffffff;\n  border: 1px solid #e2e8f0;\n}\n\n@media (max-width: 767px) {\n  .agcex-ua-card {\n    padding: 24px 18px;\n    border-radius: 12px;\n    max-width: 100%;\n  }\n\n  .agcex-ua-hero h1 {\n    font-size: 24px;\n  }\n\n  .agcex-ua-hero .agcex-ua-meta {\n    flex-wrap: wrap;\n    gap: 12px;\n  }\n}\n\n/* Summary Table */\n.agcex-ua-summary-table-wrapper {\n  margin-bottom: 30px;\n  overflow-x: auto;\n  border: 1px solid #e2e8f021;\n  border-radius: 12px;\n  background: #f8fafc14;\n\n}\n\nbody.light_theme .agcex-ua-summary-table-wrapper {\n  border: 1px solid #e2e8f0;\n  background: #f8fafc;\n}\n\n.agcex-ua-summary-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 14px;\n}\n\n.agcex-ua-summary-table tr {\n  border-bottom: 1px solid #e2e8f026;\n}\n\nbody.light_theme .agcex-ua-summary-table tr {\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.agcex-ua-summary-table tr:last-child {\n  border-bottom: none;\n}\n\n.agcex-ua-summary-table .agcex-ua-label {\n  font-weight: 600;\n  color: #ededed;\n  padding: 14px 20px;\n  width: 280px;\n  background: #383b40;\n  border-right: 1px solid #e2e8f029;\n}\n\nbody.light_theme .agcex-ua-summary-table .agcex-ua-label {\n  background: #f1f5f9;\n  border-right: 1px solid #e2e8f0;\n  color: #0f172a;\n}\n\n.agcex-ua-summary-table .agcex-ua-value {\n  color: #e7e7e7;\n  padding: 14px 20px;\n}\n\nbody.light_theme .agcex-ua-summary-table .agcex-ua-value {\n  color: #475569;\n}\n\n.agcex-ua-summary-table .agcex-ua-value a {\n  color: #ce9f4e;\n  text-decoration: none;\n  font-weight: 500;\n}\n\n.agcex-ua-summary-table .agcex-ua-value a:hover {\n  text-decoration: underline;\n}\n\n@media (max-width: 575px) {\n  .agcex-ua-summary-table .agcex-ua-label {\n    width: 140px;\n    padding: 12px 14px;\n    font-size: 13px;\n  }\n\n  .agcex-ua-summary-table .agcex-ua-value {\n    padding: 12px 14px;\n    font-size: 13px;\n  }\n}\n\n/* Intro Box */\n.agcex-ua-intro-box {\n  background: #f8fafc14;\n  border: 1px solid #cbd5e129;\n  border-radius: 12px;\n  padding: 22px 26px;\n  margin-bottom: 36px;\n  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.02);\n}\n\nbody.light_theme .agcex-ua-intro-box {\n  background: #f8fafc;\n  border: 1px solid #cbd5e1;\n}\n\n.agcex-ua-intro-box p {\n  font-size: 14px;\n  line-height: 1.8;\n  color: #ededed;\n  margin: 0;\n}\n\nbody.light_theme .agcex-ua-intro-box p {\n  color: #475569;\n}\n\n/* Table of Contents */\n.agcex-ua-toc {\n  background: #383b40;\n  border: 1px solid #e2e8f01f;\n  border-radius: 12px;\n  padding: 28px 32px;\n  margin-bottom: 40px;\n  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.02);\n}\n\nbody.light_theme .agcex-ua-toc {\n  background: #ffffff;\n  border: 1px solid #e2e8f0;\n}\n\n.agcex-ua-toc h3 {\n  font-size: 18px;\n  font-weight: 700;\n  color: #ececec;\n  margin: 0 0 20px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  border-bottom: 2px solid #e2e8f014;\n  padding-bottom: 12px;\n}\n\nbody.light_theme .agcex-ua-toc h3 {\n  color: #0f172a;\n  border-bottom: 2px solid #e2e8f0;\n}\n\n.agcex-ua-toc-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  column-gap: 40px;\n  row-gap: 12px;\n}\n\n@media (max-width: 767px) {\n  .agcex-ua-toc-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .agcex-ua-toc {\n    padding: 20px 22px;\n  }\n}\n\n.agcex-ua-toc-item {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  font-size: 14.5px;\n  color: #f5f5f5;\n  text-decoration: none;\n  padding: 4px 0;\n  transition: all 0.2s ease;\n}\n\nbody.light_theme .agcex-ua-toc-item {\n  color: #475569;\n}\n\n.agcex-ua-toc-item:hover {\n  color: #ce9f4e;\n}\n\n.agcex-ua-toc-number {\n  width: 26px;\n  text-align: right;\n  font-weight: 600;\n  color: #f0f0f0;\n  font-size: 14px;\n}\n\nbody.light_theme .agcex-ua-toc-number {\n  color: #94a3b8;\n}\n\n/* Sections */\n.agcex-ua-section {\n  margin-bottom: 42px;\n}\n\n.agcex-ua-section:last-child {\n  margin-bottom: 0;\n}\n\n.agcex-ua-section-number {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 30px;\n  height: 30px;\n  border-radius: 8px;\n  background: linear-gradient(135deg, #d1aa67, #f5c573);\n  color: #fff;\n  font-size: 14px;\n  font-weight: 700;\n  margin-right: 12px;\n  flex-shrink: 0;\n}\n\n.agcex-ua-section h2 {\n  display: flex;\n  align-items: center;\n  font-size: 20px;\n  font-weight: 700;\n  color: #ececec;\n  margin: 0 0 20px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid #e2e8f01f;\n}\n\nbody.light_theme .agcex-ua-section h2 {\n  color: #0f172a;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.agcex-ua-section p {\n  font-size: 14.5px;\n  line-height: 1.75;\n  color: #f3f3f3;\n  margin: 0 0 16px;\n}\n\nbody.light_theme .agcex-ua-section p {\n  color: #475569;\n}\n\n.agcex-ua-section p:last-child {\n  margin-bottom: 0;\n}\n\n/* Definitions List */\n.agcex-ua-definition-item {\n  margin-bottom: 22px;\n  padding-left: 16px;\n  border-left: 3px solid #e2e8f029;\n}\n\nbody.light_theme .agcex-ua-definition-item {\n  border-left: 3px solid #cbd5e1;\n}\n\n.agcex-ua-definition-item:last-child {\n  margin-bottom: 0;\n}\n\n.agcex-ua-definition-item strong {\n  display: block;\n  font-size: 15px;\n  font-weight: 700;\n  color: #f0f0f0;\n  margin-bottom: 6px;\n}\n\nbody.light_theme .agcex-ua-definition-item strong {\n  color: #0f172a;\n}\n\n.agcex-ua-definition-item p {\n  margin: 0;\n  font-size: 14.5px;\n  color: #f0f0f0;\n  line-height: 1.7;\n}\n\nbody.light_theme .agcex-ua-definition-item p {\n  color: #475569;\n}\n\n.agcex-ua-text-list p {\n  margin-bottom: 18px;\n  padding-left: 12px;\n  border-left: 3px solid #e2e8f021;\n}\n\nbody.light_theme .agcex-ua-text-list p {\n  border-left: 3px solid #e2e8f0;\n}\n\n.agcex-ua-text-list p strong {\n  color: #f1f1f1;\n}\n\nbody.light_theme .agcex-ua-text-list p strong {\n  color: #0f172a;\n}\n\n.agcex-ua-section ul {\n  list-style: none;\n  padding: 0;\n  margin: 0 0 20px;\n}\n\n.agcex-ua-section ul li {\n  position: relative;\n  padding-left: 24px;\n  margin-bottom: 12px;\n  font-size: 14.5px;\n  line-height: 1.7;\n  color: #dfdfdf;\n}\n\nbody.light_theme .agcex-ua-section ul li {\n  color: #475569;\n}\n\n.agcex-ua-section ul li strong {\n  color: #f1f1f1;\n}\n\nbody.light_theme .agcex-ua-section ul li strong {\n  color: #0f172a;\n}\n\n.agcex-ua-section ul li::before {\n  content: \"\";\n  position: absolute;\n  left: 4px;\n  top: 10px;\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #dbb26a, #f1c171);\n}\n\n/* Sub Articles */\n.agcex-ua-sub-article {\n  margin-top: 24px;\n  margin-bottom: 24px;\n  padding-left: 16px;\n  border-left: 2px solid #e2e8f029;\n}\n\nbody.light_theme .agcex-ua-sub-article {\n  border-left: 2px solid #cbd5e1;\n}\n\n.agcex-ua-sub-article h3 {\n  font-size: 16px;\n  font-weight: 700;\n  color: #ececec;\n  margin: 0 0 10px;\n}\n\nbody.light_theme .agcex-ua-sub-article h3 {\n  color: #0f172a;\n}\n\n/* Purpose Table */\n.agcex-ua-table-responsive {\n  overflow-x: auto;\n  margin-top: 20px;\n  margin-bottom: 20px;\n  border: 1px solid #e2e8f021;\n  border-radius: 12px;\n}\n\nbody.light_theme .agcex-ua-table-responsive {\n  border: 1px solid #e2e8f0;\n}\n\n.agcex-ua-purpose-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 14px;\n}\n\n.agcex-ua-purpose-table th,\n.agcex-ua-purpose-table td {\n  padding: 14px 18px;\n  text-align: left;\n  border-bottom: 1px solid #e2e8f021;\n  line-height: 1.6;\n}\n\nbody.light_theme .agcex-ua-purpose-table th,\nbody.light_theme .agcex-ua-purpose-table td {\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.agcex-ua-purpose-table th {\n  background: #383b40;\n  font-weight: 700;\n  color: #ededed;\n  font-size: 14px;\n  border-bottom: 2px solid #e2e8f029;\n}\n\nbody.light_theme .agcex-ua-purpose-table th {\n  background: #f8fafc;\n  color: #0f172a;\n  border-bottom: 2px solid #e2e8f0;\n}\n\n.agcex-ua-purpose-table td {\n  color: #dfdfdf;\n}\n\nbody.light_theme .agcex-ua-purpose-table td {\n  color: #475569;\n}\n\n.agcex-ua-purpose-table tr:last-child td {\n  border-bottom: none;\n}\n\n.agcex-ua-purpose-table tbody tr:nth-child(even) {\n  background-color: #ffffff0a;\n}\n\nbody.light_theme .agcex-ua-purpose-table tbody tr:nth-child(even) {\n  background-color: #fcfcfd;\n}\n\n.agcex-ua-purpose-table td strong {\n  color: #f5f5f5;\n}\n\nbody.light_theme .agcex-ua-purpose-table td strong {\n  color: #0f172a;\n}\n\n/* Contact Box & Table Wrapper */\n.agcex-ua-contact-box {\n  background: #f8fafc14;\n  border: 1px solid #e2e8f021;\n  border-radius: 12px;\n  padding: 24px 28px;\n  margin-top: 28px;\n}\n\nbody.light_theme .agcex-ua-contact-box {\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n}\n\n.agcex-ua-contact-box h3 {\n  font-size: 17px;\n  font-weight: 700;\n  color: #ececec;\n  margin: 0 0 12px;\n}\n\nbody.light_theme .agcex-ua-contact-box h3 {\n  color: #0f172a;\n}\n\n.agcex-ua-contact-box p {\n  font-size: 14px;\n  margin-bottom: 16px;\n}\n\n.agcex-ua-contact-table-wrapper {\n  margin-top: 20px;\n  margin-bottom: 24px;\n}\n\n/* Confirmation Divider & Text */\n.agcex-ua-divider {\n  border: 0;\n  height: 1px;\n  background: #e2e8f029;\n  margin: 40px 0 24px;\n}\n\nbody.light_theme .agcex-ua-divider {\n  background: #e2e8f0;\n}\n\n.agcex-ua-confirmation-text {\n  font-size: 15px;\n  line-height: 1.7;\n  color: #ebebeb;\n  margin-bottom: 36px;\n}\n\nbody.light_theme .agcex-ua-confirmation-text {\n  color: #334155;\n}\n\n/* Footer Grid */\n.agcex-ua-footer-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  background: #f8fafc12;\n  border: 1px solid #cbd5e114;\n  border-radius: 12px;\n  overflow: hidden;\n  margin-bottom: 24px;\n}\n\nbody.light_theme .agcex-ua-footer-grid {\n  background: #f8fafc;\n  border: 1px solid #cbd5e1;\n}\n\n.agcex-ua-footer-col {\n  padding: 20px 24px;\n  border-right: 1px solid #4c4c4c;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\nbody.light_theme .agcex-ua-footer-col {\n  border-right: 1px solid #cbd5e1;\n}\n\n.agcex-ua-footer-col:last-child {\n  border-right: none;\n}\n\n.agcex-ua-footer-col strong {\n  font-size: 14px;\n  font-weight: 700;\n  color: #f5f5f5;\n  margin-bottom: 4px;\n}\n\nbody.light_theme .agcex-ua-footer-col strong {\n  color: #0f172a;\n}\n\n.agcex-ua-footer-col span {\n  font-size: 13.5px;\n  color: #d9d9d9;\n  line-height: 1.5;\n}\n\nbody.light_theme .agcex-ua-footer-col span {\n  color: #475569;\n}\n\n.agcex-ua-footer-col span a {\n  color: #ce9f4e;\n  text-decoration: none;\n}\n\n.agcex-ua-footer-col span a:hover {\n  text-decoration: underline;\n}\n\n/* Copyright Statement */\n.agcex-ua-copyright {\n  text-align: center;\n  font-size: 13px;\n  color: #e4e4e4;\n  padding-top: 20px;\n  border-top: 1px solid #535353;\n}\n\nbody.light_theme .agcex-ua-copyright {\n  color: #64748b;\n  border-top: 1px solid #e2e8f0;\n}\n\n@media (max-width: 991px) {\n  .user_agreement {\n    padding-top: 20px;\n  }\n\n  .agcex-ua-section h2 {\n    font-size: 18px;\n  }\n\n  .agcex-ua-footer-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .agcex-ua-footer-col {\n    border-right: none;\n    border-bottom: 1px solid #4c4c4c;\n  }\n\n  body.light_theme .agcex-ua-footer-col {\n    border-right: none;\n    border-bottom: 1px solid #cbd5e1;\n  }\n\n  .agcex-ua-footer-col:last-child {\n    border-bottom: none;\n  }\n}\n\n.agcex-ua-risk-summary-box {\n  border-radius: 8px;\n  padding: 16px 20px;\n  margin-bottom: 24px;\n  font-size: 13.5px;\n  font-weight: 700;\n  line-height: 1.6;\n  border: 1px solid #424242;\n  color: #ffffff;\n  background-color: #ffffff0f;\n  letter-spacing: 0.2px;\n  text-align: justify;\n}\n\nbody.light_theme .agcex-ua-risk-summary-box {\n  border: 1px solid #0f172a;\n  color: #0f172a;\n  background-color: #ffffff;\n}\n\n\n@media screen and (max-width:1200px) {\n\n  .user_agreement .agcex-ua-card {\n    max-width: 100%;\n  }\n\n  .agcex-ua-section p {\n    font-size: 14px;\n  }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
